import { render, staticRenderFns } from "./StudentList.vue?vue&type=template&id=1589eedb&scoped=true&"
import script from "./StudentList.vue?vue&type=script&lang=js&"
export * from "./StudentList.vue?vue&type=script&lang=js&"
import style0 from "./StudentList.vue?vue&type=style&index=0&id=1589eedb&lang=scss&scoped=true&"
import style1 from "./StudentList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1589eedb",
  null
  
)

export default component.exports